/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyertooldescription2Inputs */

const en_flyertooldescription2 = /** @type {(inputs: Flyertooldescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compose a print or story flyer with a QR code.`)
};

const de_flyertooldescription2 = /** @type {(inputs: Flyertooldescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Druck- oder Story-Flyer mit QR-Code gestalten.`)
};

/**
* | output |
* | --- |
* | "Compose a print or story flyer with a QR code." |
*
* @param {Flyertooldescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyertooldescription2 = /** @type {((inputs?: Flyertooldescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyertooldescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyertooldescription2(inputs)
	return de_flyertooldescription2(inputs)
});
export { flyertooldescription2 as "flyerToolDescription" }